import { Trans } from '@lingui/macro';
import NgpTextField from '../../form/NgpTextField';
import NgpPasswordField from '../../form/NgpPasswordField';
import FormSection from '../../form/FormSection';
import { AGENT_BTT_USER_DOMAIN_FIELD, AGENT_BTT_USERNAME_FIELD, AGENT_BTT_USER_PASSWORD_FIELD } from './AgentConstants';

export function AgentBTTUser() {
    return (
        <FormSection title={<Trans>Run Business Transaction Test as User</Trans>}>
            <NgpTextField
                label={<Trans>Domain (Leave empty for local account)</Trans>}
                inputProps={{
                    size: 40,
                }}
                fieldName={AGENT_BTT_USER_DOMAIN_FIELD}
            />
            <NgpTextField label={<Trans>Username</Trans>} fieldName={AGENT_BTT_USERNAME_FIELD} />
            <NgpPasswordField fieldName={AGENT_BTT_USER_PASSWORD_FIELD} label={<Trans>Password</Trans>} />
        </FormSection>
    );
}
